import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Card, Grid, Tabs, Tab, Box } from "@mui/material";
import { CloudUpload as CloudUploadIcon, ListAlt as ListAltIcon } from "@mui/icons-material";

import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import FormImportacionLazo from "../Form/FormImportacionLazo";
import TableLazo from "../TableLazo";

const HeaderLazo = ({ refreshFlag, onError, onSuccess }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [lotFilter, setLotFilter] = useState("");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleImportSuccess = useCallback(
    (result) => {
      if (onSuccess) {
        onSuccess(result.message || "Tags importados exitosamente");
      }
      setTimeout(() => {
        setActiveTab(1);
      }, 1500);
    },
    [onSuccess]
  );

  const tabsConfig = [
    {
      label: "Importar Datos",
      icon: <CloudUploadIcon sx={{ fontSize: 20, mr: 1 }} />,
      value: 0,
      description: "Importe datos desde archivo Excel",
    },
    {
      label: "Lista de Registros",
      icon: <ListAltIcon sx={{ fontSize: 20, mr: 1 }} />,
      value: 1,
      description: "Administre los registros existentes",
    },
  ];

  const lotNumber = lotFilter && !isNaN(lotFilter) ? parseInt(lotFilter, 10) : null;

  return (
    <MDBox position="relative" sx={{ mt: -2, mx: -3, py: 2, px: -2 }}>
      <Card
        sx={{
          mt: 1,
          mx: 3,
          py: 3,
          px: 3,
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #1e293b 0%, #0b4f6c 100%)",
            margin: -3,
            marginBottom: 3,
            padding: 3,
            borderBottom: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
            <Grid item xs={12} md={6}>
              <MDTypography variant="h4" fontWeight="bold" sx={{ color: "rgba(255, 255, 255)" }}>
                Gestión de Registros - Lazo
              </MDTypography>
              <MDTypography variant="body2" sx={{ color: "rgba(255,255,255,0.7)", mt: 0.5 }}>
                Importe y administre los registros del sistema
              </MDTypography>
            </Grid>
          </Grid>
        </Box>

        {/* Tabs */}
        <Box sx={{ mb: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabs-indicator": {
                height: 3,
                borderRadius: "3px 3px 0 0",
                background: "linear-gradient(90deg, #0b4f6c 0%, #1e7e6c 100%)",
              },
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.875rem",
                minHeight: 48,
                transition: "all 0.2s",
                "&:hover": {
                  backgroundColor: "rgba(11, 79, 108, 0.04)",
                  borderRadius: 1,
                },
                "&.Mui-selected": {
                  color: "#0b4f6c",
                },
              },
            }}
          >
            {tabsConfig.map((tab) => (
              <Tab key={tab.value} icon={tab.icon} label={tab.label} iconPosition="start" />
            ))}
          </Tabs>
        </Box>

        {/* Contenido */}
        <Box sx={{ mt: 2 }}>
          {activeTab === 0 && (
            <Box sx={{ animation: "fadeIn 0.3s ease-in-out" }}>
              <FormImportacionLazo onImportSuccess={handleImportSuccess} onError={onError} />
            </Box>
          )}

          {activeTab === 1 && (
            <Box sx={{ animation: "fadeIn 0.3s ease-in-out" }}>
              <TableLazo refreshFlag={refreshFlag} onError={onError} lot={lotNumber} />
            </Box>
          )}
        </Box>
      </Card>
    </MDBox>
  );
};

HeaderLazo.propTypes = {
  refreshFlag: PropTypes.bool,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
};

HeaderLazo.defaultProps = {
  refreshFlag: false,
  onError: null,
  onSuccess: null,
};

export default HeaderLazo;
